<template>
    <div>
        <div
            class="app-overlay"
            :class="{ hide: !isOpen }"
            :style="overlayStyles"
        ></div>
        <div class="app-modal" :class="modalClassesArr" :style="modalStyles">
            <div class="app-modal__close" @click="onCloseModal"></div>
            <div class="app-modal__header flex">
                <div class="subtitle1 app-modal__title">{{ title }}</div>
            </div>
            <div class="app-modal__body" :class="{ 'mb-0': hideFooter }">
                <slot></slot>
            </div>
            <div
                v-if="!hideFooter"
                class="app-modal__footer flex flex-justify-end"
                :class="footerClasses"
            >
                <button
                    type="button"
                    class="cabinet-btn cabinet-btn--default js-modal-close"
                    :class="btnCancelClasses"
                    :disabled="disabled"
                    @click="onCloseModal"
                >
                    Отменить
                </button>
                <button
                    type="button"
                    class="cabinet-btn js-modal-close app-modal__btn"
                    :class="btnSaveClassList"
                    :disabled="disabled"
                    @click="onSaveModal"
                >
                    {{ btnSaveTitle }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        btnSaveTitle: {
            type: String,
            default: 'Сохранить'
        },
        btnSaveClasses: {
            type: Array,
            default: function() {
                return []
            }
        },
        btnCancelClasses: {
            type: Array,
            default: function() {
                return []
            }
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        footerClasses: {
            type: Array,
            default: function() {
                return []
            }
        },
        overlayZIndex: {
            type: Number,
            default: null
        },
        modalClasses: {
            type: String,
            default: ''
        },
        modalZIndex: {
            type: Number,
            default: null
        }
    },
    computed: {
        btnSaveClassList() {
            let classObj = {
                loading: this.isLoading
            }
            this.btnSaveClasses.forEach(item => {
                classObj[item] = true
            })
            return classObj
        },
        overlayStyles() {
            return this.overlayZIndex
                ? {
                      'z-index': this.overlayZIndex
                  }
                : {}
        },
        modalClassesArr() {
            let arr = []
            if (!this.isOpen) {
                arr.push('hide')
            }
            if (this.modalClasses) {
                arr.push(this.modalClasses.split(' '))
            }
            return arr
        },
        modalStyles() {
            return this.modalZIndex
                ? {
                      'z-index': this.modalZIndex
                  }
                : {}
        }
    },
    methods: {
        onCloseModal() {
            this.$emit('onCloseModal')
        },
        onSaveModal() {
            this.$emit('onSaveModal')
        }
    }
}
</script>
